import styled from '@emotion/styled'

import WebsiteListForm from './WebsiteListForm'
import Button from 'components/Button'
import { GlobeIcon } from 'components/icons'
import { ensureProtocol } from 'lib/helpers'

const Website = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	height: min-content;
`

const SingleWebsiteItemOuter = styled.div`
	width: 100%;
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: flex-start;
	border-radius: ${({ theme }) => theme.borderRadiuses.xxl};
	gap: ${({ theme }) => theme.spaces.space4};
	${({ theme }) => theme.typography.caption};
	padding: ${({ theme }) => theme.spaces.space5};
	background-color: ${({ theme }) => theme.colors.light.grayscale[15]};
	border: 1px solid ${({ theme }) => theme.colors.light.borderColor};
	margin-bottom: ${({ theme }) => theme.spaces.space4};
	row-gap: ${({ theme }) => theme.spaces.space6};
`

type Props = {
	handleRecommendationsConnect: (domain: string | null) => void
	domains: string[]
}

const WebsiteSelectionStep = ({ handleRecommendationsConnect, domains }: Props) => {
	return (
		<>
			{domains.length === 1 ? (
				<SingleWebsiteItemOuter>
					<GlobeIcon data-testid="globe-icon" />
					<Website>{ensureProtocol(domains[0])}</Website>
					<Button
						fullWidth
						kind="primary"
						type="button"
						disableHover
						onClick={() => handleRecommendationsConnect(ensureProtocol(domains[0]))}
						aria-label={`Search for products on ${ensureProtocol(domains[0])}`}
						mediumDesktop
					>
						Set up
					</Button>
				</SingleWebsiteItemOuter>
			) : (
				<WebsiteListForm domains={domains} onSubmit={handleRecommendationsConnect} />
			)}
		</>
	)
}

export default WebsiteSelectionStep
